import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";

interface AcaoExternaContentProps {
  tarefa: {
    id: number;
    erro?: string | null;
    sucesso?: string | null;
    extras?: {
      processando?: boolean;
      acao_externa?: {
        monitoramento?: {
          mensagem: string;
          tentativas: number;
          limite_tentativas: number;
          aguardando: boolean;
        } | null;
        reprocessamento_automatico?: boolean;
        permitir_reprocessar?: "Sempre" | "Somente com erro" | string;
        permitir_reprocessar_label?: string;
      } | null;
    } | null;
  };
}

export default function AcaoExternaContent({ tarefa }: AcaoExternaContentProps) {
  const queryClient = useQueryClient();

  const { mutate: reprocessarTarefa, isLoading: isLoadingReprocessarTarefa } = useMutation({
    mutationKey: 'reprocessar-acao-externa-content',
    mutationFn: () => axiosClient.post("/reprocessar-acao-externa", { tarefa_id: tarefa.id }),
    onSuccess: () => {
      enqueueSnackbar('Reprocessamento realizado com sucesso!', { variant: 'success' });
      queryClient.invalidateQueries("detalhar-processo");
    }
  });

  const acaoExterna = tarefa.extras?.acao_externa;
  const monitoramento = acaoExterna?.monitoramento;
  const auto = acaoExterna?.reprocessamento_automatico === true;

  if (auto && monitoramento) {
    const { mensagem, tentativas, limite_tentativas, aguardando } = monitoramento;

    return (
      <Box mt={1} display="flex" flexDirection="column" gap={0.5}>
        <Box display="flex" alignItems="center" gap={1}>
          {aguardando && <CircularProgress size="1rem" />}
          <Typography variant="caption">
            {mensagem}
          </Typography>
        </Box>
        {limite_tentativas > 0 && (
          <Typography variant="caption">
            Tentativa {tentativas} de {limite_tentativas}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <>
      {tarefa.erro && (
        <Typography variant="caption" color="error">
          {tarefa.erro}
        </Typography>
      )}

      {tarefa.sucesso && (
        <Typography variant="caption">
          {tarefa.sucesso}
        </Typography>
      )}

      {tarefa.extras?.processando && (
        <CircularProgress size="1rem" />
      )}

      {!tarefa.extras?.processando &&
        (acaoExterna?.permitir_reprocessar === "Sempre" ||
          (acaoExterna?.permitir_reprocessar === "Somente com erro" && tarefa.erro)) && (
          <Box mt={1}>
            <Button
              variant="outlined"
              size="small"
              disabled={isLoadingReprocessarTarefa}
              onClick={() => reprocessarTarefa()}
            >
              {isLoadingReprocessarTarefa && (
                <CircularProgress size={18} sx={{ mr: 1 }} />
              )}
              {acaoExterna?.permitir_reprocessar_label || "Reprocessar"}
            </Button>
          </Box>
        )}
    </>
  );
}